/**
 * Open popup.
 *
 * @param   {Event}  event
 * @param   {Node}  button
 * @return  {Void}
 */
function openPopup(event, button) {

	if (button.closest('.tile-plans').querySelector('.js-popup')) {
		button
			.closest('.tile-plans')
			.querySelector('.js-popup')
			.classList.add('is-active');

		document
			.querySelector('.js-popup-overlay')
			?.classList.add('is-active');

		document
			.querySelector('body')
			.classList.add('has-popup-open');

		event.preventDefault();
	}
}

/**
 * Close popup.
 *
 * @param   {Event}  event
 * @return  {Void}
 */
function closePopup(event) {
	document
		.querySelector('.js-popup.is-active')
		?.classList.remove('is-active');

	document
		.querySelector('.js-popup-overlay.is-active')
		?.classList.remove('is-active');

	document
		.querySelector('body')
		.classList.remove('has-popup-open');

	event.preventDefault();
}

/**
 * Tiles popups actions.
 */
document.querySelectorAll('.js-popup-trigger').forEach(button => {
	button.addEventListener('click', (event) => openPopup(event, button));
});

document.querySelectorAll('.js-popup-close').forEach(button => {
	button.addEventListener('click', (event) => closePopup(event));
});

document.querySelectorAll('.js-popup-overlay').forEach(button => {
	button.addEventListener('click', (event) => closePopup(event));
});

/**
 * Scroll to section functionality.
 */
document.querySelectorAll('.js-scroll-to-section').forEach(link => {
	link.addEventListener('click', function (event) {
		const targetSection = link.getAttribute('href');
		const headerHeight = document.querySelector('.header').offsetHeight;
		
		window.scrollTo({
			top: document.querySelector(targetSection).offsetTop - headerHeight,
			left: 0,
			behavior: "smooth",
		});

		event.preventDefault();
	});
});


document.addEventListener('DOMContentLoaded', function() {
	// Select all containers that have the radio buttons and p tags
	const sections = document.querySelectorAll('.tile-plans');
  
	sections.forEach(section => {
	  // Select radio buttons within this section
	  const radioButtons = section.querySelectorAll('input[type="radio"][name="id"]');
  
	  // Function to handle radio button change event
	  function handleRadioButtonChange(event) {
		const selectedVariantId = event.target.value;
  
		// Select all <p> elements with data-variant-id attribute within this section
		const variantElements = section.querySelectorAll('p[data-variant-id]');
  
		// Toggle visibility based on the selected radio button value
		variantElements.forEach(p => {
		  if (p.getAttribute('data-variant-id') === selectedVariantId) {
			p.style.display = 'block';  // Show the matching <p>
		  } else {
			p.style.display = 'none';   // Hide the non-matching <p>
		  }
		});
	  }
  
	  // Attach change event listeners to all radio buttons within this section
	  radioButtons.forEach(radio => {
		radio.addEventListener('change', handleRadioButtonChange);
	  });
  
	  /* Initial trigger to set the correct visibility on page load within this section
	  const checkedRadioButton = section.querySelector('input[type="radio"][name="id"]:checked');
	  if (checkedRadioButton) {
		handleRadioButtonChange({ target: checkedRadioButton });
	  } */
	});
  });
  
  
  